<template>
  <div class="page-left-nav">
    <div class="pageLefTop flex align-center justify-center">
      <div>
        <div class="diamond diamondR"></div>
        <div class="diamond diamondT"></div>
      </div>
      <div>
        <div class="diamond"></div>
        <div class="diamond diamondT"></div>
      </div>
    </div>

    <div class="hc_sidebar fl">
      <el-menu :unique-opened="true" :default-active="activeIndex">
        <template v-for="(item,idx) in menuList">
          <!-- 一级菜单 -->
          <template v-if="!item.children">
            <el-menu-item
              :index="item.path"
              :key="item.path"
              @click="getNav(item.path,idx)"
            >{{item.menuName}}</el-menu-item>
          </template>

          <!-- 二级菜单 -->
          <template v-else>
            <el-submenu :index="item.path" :key="item.path">
              <template slot="title">
                <span>{{item.menuName}}</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item
                @click="getNav(itemTwo.path,idx)"
                :index="itemTwo.path"
                v-for="(itemTwo,index) in item.children"
                :key="index"
              >{{itemTwo.menuName}}</el-menu-item>
            </el-submenu>
          </template>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "left-nav",
  data() {
    return {
      activeIndex: "/",
      navPath: "",
      menuList: [
        {
          active: true,
          menuName: "首页",
          path: "/",
        },
        {
          active: false,
          menuName: "锐信应用",
          path: "/experience",
          children: [
            {
              active: false,
              menuName: "我的模板",
              path: "/userTemplate",
            },
            {
              active: false,
              menuName: "锐信发送",
              path: "/fuxinSend",
            },
            {
              active: false,
              menuName: "锐信体验",
              path: "/experience",
            },
          ],
        },
        {
          active: false,
          menuName: "锐信记录",
          path: "/send",
          children: [
            {
              active: false,
              menuName: "发送任务记录",
              path: "/send",
            },
          ],
        },
        {
          active: false,
          menuName: "系统管理",
          path: "/news",
          children: [
            {
              active: false,
              menuName: "系统消息",
              path: "/news",
            },
            {
              active: false,
              menuName: "我的账户",
              path: "/user",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  // 一启动就加载
  mounted() {},
  watch: {},
  created() {
    this.checkout();
  },
  methods: {
    checkout() {
      let path = this.$route.path;
      this.activeIndex = path;
    },
    getNav(router, idx) {
      let menuList = this.menuList;
      for (let item of menuList) {
        item.active = false;
      }
      menuList[idx].active = true;
      this.menuList = menuList;
      if (this.$route.path != router) {
        this.$router.push({
          path: router,
        });
      }
    },
  },
  bus: {
    //动态更改菜单栏
    checkNav(e) {
      this.checkout();
      this.activeIndex = e.path;
    },
  },
};
</script>

<style>
.hc_sidebar .el-menu {
  background-color: transparent !important;
  border-right: inherit;
}
.pageLefTop {
  height: 0.6rem;
  cursor: pointer;
}
.diamond {
  width: 0.11rem;
  height: 0.11rem;
  background: #d1d3d7;
  opacity: 0.8;
}
.diamondR {
  margin-right: 0.02rem;
}
.diamondT {
  margin-top: 0.02rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/left-nav.vue